import WhatsAppIcon from '@/components/ui/Icons/WhatsAppIcon';

export const WhatsAppWidget = () => {
  const linkNumber = '31631206927';

  return (
    <a target="_blank" href={`https://wa.me/${linkNumber}`}>
      <div
        className={
          'fixed bottom-5 right-5 z-999 h-14 w-14 rounded-lg bg-whatsapp-green'
        }
      >
        <WhatsAppIcon id={'whatsapp-help'} />
      </div>
    </a>
  );
};
